import { Component, OnInit } from '@angular/core';
import { ContractService, SupportDataService } from '../../_services';
import { ContractBase } from "./contract.base";

@Component({
	selector: 'contract-general-contract-info',
	template: require('./contract-general-contract-info.template.html')
})
export class ContractGeneralContractInfoComponent extends ContractBase implements OnInit {

	constructor(
		public readonly api: SupportDataService,
		public readonly contractService: ContractService) {
		super(contractService);
	}


	guarantees$: Promise<any[]>;
	units$: Promise<any[]>;

	ngOnInit(): void {
		this.guarantees$ = this.api.contract.guarantees();
		this.units$ = this.api.contract.units();
	}

	ngOnDestroy(): void {
	}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/contract-general-contract-info.component.ts